(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-testid="product-list"]').forEach((section) => {
      const thumb = section.querySelector('.product-carousel-thumb');
      const trackEl = section.querySelector('.product-carousel-track');
      const slides = section.querySelector('slideshow-slides');
      if (!thumb || !trackEl || !slides) return;

      function update() {
        const scrollable = slides.scrollWidth - slides.clientWidth;
        if (scrollable <= 0) { thumb.style.width = '100%'; return; }
        const thumbWidth = (slides.clientWidth / slides.scrollWidth) * 100;
        const thumbLeft  = (slides.scrollLeft / slides.scrollWidth) * 100;
        thumb.style.width = thumbWidth + '%';
        thumb.style.left  = thumbLeft + '%';
      }

      update();
      slides.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      /* Sürükleme */
      let dragging = false, startX = 0, startScroll = 0;

      thumb.addEventListener('pointerdown', (e) => {
        dragging = true;
        startX = e.clientX;
        startScroll = slides.scrollLeft;
        thumb.classList.add('is-dragging');
        thumb.setPointerCapture(e.pointerId);
        e.preventDefault();
      });

      thumb.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - startX;
        const ratio = slides.scrollWidth / trackEl.clientWidth;
        slides.scrollLeft = startScroll + dx * ratio;
      });

      thumb.addEventListener('pointerup', () => {
        dragging = false;
        thumb.classList.remove('is-dragging');
      });

      /* Track'e tıklayınca oraya atla */
      trackEl.addEventListener('click', (e) => {
        if (e.target === thumb) return;
        const rect = trackEl.getBoundingClientRect();
        const pct  = (e.clientX - rect.left) / rect.width;
        slides.scrollLeft = pct * (slides.scrollWidth - slides.clientWidth);
      });
    });
  })();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swist-lead-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var COOKIE  = '{{ cookie_key }}';
  var DELAY   = '4';
  var TRIGGER = '{{ section.settings.trigger }}';
  var root    = document.getElementById('slp-root');
  if (!root) return;

  function getCookie(k) {
    return document.cookie.split('; ').reduce(function (a, p) {
      var s = p.split('='); return s[0] === k ? decodeURIComponent(s[1]) : a;
    }, null);
  }
  function setCookie(k, v, days) {
    document.cookie = k + '=' + encodeURIComponent(v) +
      '; expires=' + new Date(Date.now() + days * 864e5).toUTCString() +
      '; path=/; SameSite=Lax';
  }

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var first = root.querySelector('.slp-input, .slp-tel-inp');
      if (first) first.focus();
    }, 460);
  }

  function close(remember) {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (remember !== false) setCookie(COOKIE, '1', 30);
  }

  function validateConsents() {
    var ok = true;
    root.querySelectorAll('.slp-cb-input[required]').forEach(function (cb) {
      cb.classList.remove('is-invalid');
      if (!cb.checked) {
        ok = false;
        cb.classList.add('is-invalid');
        setTimeout(function () { cb.classList.remove('is-invalid'); }, 400);
      }
    });
    return ok;
  }

  function showSuccess() {
    var formEl  = document.getElementById('slp-form');
    var success = document.getElementById('slp-success');
    if (formEl)  formEl.style.display = 'none';
    if (success) success.classList.add('is-visible');
    setCookie(COOKIE, '1', 365);
    setTimeout(function () { close(false); }, 4000);
  }

  // ── Telefon-only modda sahte Gmail üret ──
  var emailInput = document.getElementById('slp-email');
  var phoneInput = document.getElementById('slp-phone');
  var formEl     = document.getElementById('slp-form');

  if (!emailInput && phoneInput && formEl) {
    var hiddenEmail = document.createElement('input');
    hiddenEmail.type  = 'hidden';
    hiddenEmail.name  = 'contact[email]';
    hiddenEmail.value = 'popup-0000000000@gmail.com';
    formEl.insertBefore(hiddenEmail, formEl.firstChild);

    phoneInput.addEventListener('input', function () {
      var digits = phoneInput.value.replace(/\D/g, '');
      if (digits.length > 0) {
        hiddenEmail.value = 'popup-' + digits + '@gmail.com';
      } else {
        hiddenEmail.value = 'popup-0000000000@gmail.com';
      }
    });
  }
  // ─────────────────────────────────────────

  var submit       = document.getElementById('slp-submit');
  var backdrop     = document.getElementById('slp-backdrop');
  var closeBtn     = document.getElementById('slp-close');
  var successClose = document.getElementById('slp-success-close');

  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      if (!validateConsents()) { e.preventDefault(); return; }
   var phoneInput = document.getElementById('slp-phone');
    if (phoneInput && phoneInput.value) {
      var digits = phoneInput.value.replace(/\D/g, '');
      if (digits.charAt(0) === '0') digits = digits.substring(1);
      phoneInput.value = '+90' + digits;
    }
      if (submit) { submit.classList.add('is-loading'); submit.disabled = true; }
    });
  }

  function checkResult() {
    if (document.getElementById('slp-posted-ok')) {
      open(); showSuccess();
    } else if (document.getElementById('slp-posted-err')) {
      open();
    }
  }

  if (backdrop)     backdrop.addEventListener('click', function () { close(); });
  if (closeBtn)     closeBtn.addEventListener('click', function () { close(); });
  if (successClose) successClose.addEventListener('click', function () { close(false); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  function initTrigger() {
    if (getCookie(COOKIE)) return;

    if (TRIGGER === 'exit') {
      var fired = false;
      document.addEventListener('mouseleave', function (e) {
        if (fired || e.clientY > 20) return;
        fired = true; open();
      });
      if (/Mobi|Android/i.test(navigator.userAgent)) {
        setTimeout(open, DELAY * 1000);
      }
    } else if (TRIGGER === 'scroll') {
      var scrollFired = false;
      window.addEventListener('scroll', function () {
        if (scrollFired) return;
        var pct = window.scrollY / (document.body.scrollHeight - window.innerHeight);
        if (pct >= 0.4) { scrollFired = true; open(); }
      }, { passive: true });
    } else {
      setTimeout(open, DELAY * 1000);
    }
  }

  checkResult();
  initTrigger();

})();

  } catch(e) { console.error(e); }
})();
})();
